import script from "./inbox-unread-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./inbox-unread-panel.vue?vue&type=script&setup=true&lang=js"

import "./inbox-unread-panel.vue?vue&type=style&index=0&id=1a409489&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a409489"]])

export default __exports__